<template>
    <div class="range px-360" :style="{background:'url('+ bg + ') no-repeat center',backgroundSize:'100% 100%'}">
        <div class="tips hidden-xs-only" :style="{background:'url('+ tipBg + ') no-repeat center',backgroundSize:'100% 100%'}">
            <p>{{info[0]}}<br>{{info[1]}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        bg: String
    },
    data(){
        return{
            yyMessage: '业务范围',
            info:['企业立足山东，面向全国的院校、医院开展合作','进行市场拓展'],
            tipBg:require('@/assets/abBox.png')
        }
    }
}
</script>

<style lang="scss" scoped>
.range{
    // height: 40.625rem;
    height: vw(647);
    position: relative;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;

    .tips{
        width: vw(456);
        height: 10.3125rem;
        position: absolute;
        top: vw(152);
        left: vw(381);

        p{
            font-size: vw(18);
            margin: 0;
            padding-top: 1.8rem;
            font-weight: 500;
            line-height: 2.2;
            color: white;
        }
    }

}
@media only screen and (max-width: 767px){
  .range {
    height: vp(401);
  }
}
</style>